<template>
  <div class="setup-steps px-i">
    <div class="setup-steps-wrapper container-fluid"
         :class="{ 'justify-content-start': twoSetupItems }">
      <div v-if="hasSetupStage(1)" class="setup-item">
        <router-link :to="company.id ? `/merchant/${company.id}/profile` : `/merchant/profile/new`"
                     class="setup-item-link"
                     :class="textClass(1)">
          <i class="demo-icon" :class="circleClass(1)" />
          <span class="setup-item-link-text">
            {{ $t('setup.createMerchantProfile') }}
          </span>
        </router-link>
      </div>
      <div v-if="hasSetupStage(2)" class="setup-item">
        <router-link v-if="setupStageCheck(2)"
                     :to="`/merchant/${company.id}/account`"
                     class="setup-item-link"
                     :class="textClass(2)">
          <i class="demo-icon" :class="circleClass(2)" />
          <span class="setup-item-link-text">
            {{ $t('setup.createMerchantAccount') }}
          </span>
        </router-link>
        <span v-else class="setup-item-link setup-item-link-disabled">
          <i class="demo-icon icon-circle-2" />
          <span class="setup-item-link-text">
            {{ $t('setup.createMerchantAccount') }}
          </span>
        </span>
      </div>
      <div v-if="hasSetupStage(3)" class="setup-item">
        <router-link v-if="setupStageCheck(3)"
                     to="/templates/new"
                     class="setup-item-link"
                     :class="textClass(3)">
          <i class="demo-icon" :class="circleClass(3)" />
          <span class="setup-item-link-text">
            {{ $t('setup.createInvoiceTemplate') }}
          </span>
        </router-link>
        <span v-else class="setup-item-link setup-item-link-disabled">
          <i class="demo-icon icon-circle-3" />
          <span class="setup-item-link-text">
            {{ $t('setup.createInvoiceTemplate') }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import SetupStore from "./SetupStore";
import CompanyStore from "../Company/CompanyStore";

export default {
  name: "SetupSteps",

  data: function () {
    return {
      setupStoreState: SetupStore.state,
      setupStoreStages: SetupStore.setupStages,
      companyStoreState: CompanyStore.state
    };
  },

  computed: {
    company () {
      return this.companyStoreState.company;
    },

    setupStage () {
      return this.setupStoreState.stage;
    },

    setupComplete () {
      return this.setupStage === 4;
    },

    twoSetupItems () {
      return Object.keys(this.setupStoreStages).length === 2;
    }
  },

  methods: {
    textClass (step) {
      if (this.setupStage > step) {
        return "setup-item-link-done";
      } else {
        return "";
      }
    },

    circleClass (step) {
      if (this.setupStage > step) {
        return "icon-circle-check";
      } else {
        return `icon-circle-${step}`;
      }
    },

    setupStageCheck (step) {
      return this.setupStage >= step;
    },

    hasSetupStage (stage) {
      return this.setupStoreStages[stage];
    }
  }
};
</script>
